export { default as getReactionResourceData } from './utils/getReactionResourceData';
export { EmojiIcon, ReactionsMap } from './utils/reactionsData';
